export default __webpack_public_path__ + "static/media/our3.40d5fb88.png";